<template>
  <div>
    <list
      row-key="Junior9Id"
      ref="list"
      unit="丘成桐少年班、信息特长生初三年级"
      :page="page"
      :query-params="params"
      :show-checkbox="true"
      :show-query="showQuery"
      :get-data-func="api.list"
      :page-sizes="[10,20,50,500,1000,2000,5000]"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="报名序号">
          <el-input v-model="params.EnrollNo" placeholder="请输入报名序号" clearable />
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="params.FullName" placeholder="请输入姓名" clearable />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="params.Status" placeholder="请选择状态" clearable>
            <!-- <el-option label="待提交" :value="0"></el-option> -->
            <el-option label="待审核" :value="1"></el-option>
            <el-option label="审核未通过" :value="2"></el-option>
            <el-option label="审核通过" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="丘成桐少年班" class="lg">
          <el-select v-model="params.EnrollQct" placeholder="请选择" clearable>
            <el-option label="是" :value="true"></el-option>
            <el-option label="否" :value="false"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="信息学特长生" class="lg">
          <el-select v-model="params.EnrollInfo" placeholder="请选择" clearable>
            <el-option label="是" :value="true"></el-option>
            <el-option label="否" :value="false"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="综合素质得分" class="longLabel">
          <el-select v-model="params.QualityScore" placeholder="请选择得分" clearable>
            <el-option label="25分" :value="0"></el-option>
            <el-option label="24分" :value="1"></el-option>
            <el-option label="23分" :value="2"></el-option>
            <el-option label="≤22分" :value="3"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column type="index" label="序号" width="60" align="center" />
        <el-table-column prop="EnrollNo" label="报名序号" />
        <el-table-column prop="FullName" label="姓名" />
        <el-table-column prop="Sex" label="性别">
          <template slot-scope="{row}">
            <span v-if="row.Sex==1">男</span>
            <span v-else>女</span>
          </template>
        </el-table-column>
        <el-table-column prop="MiddleSchool" label="毕业学校" />
        <el-table-column prop="IdCard" label="证件号" />
        <el-table-column prop="MiddleExamNo" label="中考报名号" />
        <el-table-column label="报名类型" width="190">
          <template slot-scope="{row}">
            <span v-if="row.EnrollInfo&&row.EnrollQct">丘成桐少年班、信息学特长生</span>
            <span v-else-if="row.EnrollQct">丘成桐少年班</span>
            <span v-else-if="row.EnrollInfo">信息学特长生</span>
          </template>
        </el-table-column>
        <el-table-column prop="QualityScore" label="综合素质得分">
          <template slot-scope="{row}">
            <span v-if="row.QualityScore==0">25分</span>
            <span v-else-if="row.QualityScore==1">24分</span>
            <span v-else-if="row.QualityScore==2">23分</span>
            <span v-else-if="row.QualityScore==3">≤22分</span>
          </template>
        </el-table-column>
        <el-table-column prop="Status" width="100px" label="状态" align="center">
          <template slot-scope="{row}">
            <el-tag type="info" v-if="row.Status==0">待提交</el-tag>
            <el-tag type="primary" v-else-if="row.Status==1">待审核</el-tag>
            <el-tag type="danger" v-else-if="row.Status==2">审核未通过</el-tag>
            <el-tag type="success" v-else-if="row.Status==3">审核通过</el-tag>
          </template>
        </el-table-column>
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/po/junior9").default,
      params: {
        EnrollNo: "",
        FullName: "",
        EnrollInfo: null,
        EnrollQct: null,
        QualityScore: null,
        Status: null,
        Statuses: [1,2,3],
      },
    };
  },
  methods: {
    toExport(name) {
      this.api[name](this.$commonJs.obj.removeNullKey(this.$refs.list.tempQueryParams));
    },
  },
};
</script>
<style lang="scss">
  .lg {
    .el-form-item__label {
      width: 120px !important;
    }
    .el-form-item__content {
      margin-left: 120px !important;
    }
  }
</style>